export default {
    namespaced: true,
    state: {
        modalVisible: false,
        otherInfo: []
    },
    mutations: {
        showModal(state) {
            state.modalVisible = true;
        },
        hideModalSmall(state) {
            state.modalVisible = false;
        },
        setOtherInfo(state, data) {
            state.otherInfo.push(...data);
        },
    },
    getters: {
        call(state) {
            return state.modalVisible;
        },
        otherInfo(state) {
            return state.otherInfo;
        },
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/smallModal.js